module.exports = __webpack_public_path__ + "img/top-category-health.9e91aa79.jpg";